
export default {
  name: 'SettingsTable',
  props: {
    blocks: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      i18n: 'pages.education.settings.table'
    }
  },

  computed: {
    filteredBlocks() {
      const filteredBlocks = {}
      for (const [key, value] of Object.entries(this.blocks)) {
        if (value) {
          filteredBlocks[key] = value
        }
      }

      return filteredBlocks
    },

    directivesActiveBlocksCount() {
      const counters = {}
      Object.entries(this.blocks).forEach(([key, directive]) => {
        counters[key] = 0

        if (typeof directive === 'object') {
          Object.values(directive).forEach(block => {
            if (block.visible) {
              counters[key]++
            }
          })
        }
      })

      return counters
    }
  },

  methods: {
    checkIsLastActive(directive) {
      return this.directivesActiveBlocksCount[directive] < 2
    },

    async changeBlockStatus(value, block) {
      block.isLoading = true
      const response = await this.$store.dispatch(
        'education/setBlockVisibleStatus',
        [value, block.id]
      )

      if (!response?.status || response?.status !== 'ok') {
        block.visible = !value
      }
      block.isLoading = false
    }
  }
}
